import templateUrl from './trip-provider-slider.html';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import head from 'lodash/head';
import map from 'lodash/map';

export const tripProviderSliderComponent = {
    bindings: {
        details: '<',
        selectedServiceType: '<',
        title: '@',
        viewDetails: '&',
        onRouteChange: '&',
        privateTravelTime: '@',
        privateTravelTimeUnit: '@',
        distance: '@'
    },

    templateUrl,

    controller: class TripProviderSliderComponent {
        $onInit() {
            this._getActiveDetails();
        }

        previous() {
            const previousIndex = this.activeDetailIndex - 2;
            if(this.details[previousIndex]) {
                this._activeDetails(previousIndex);
                this._getActiveDetails();
                this.onRouteChange({
                    $event: this.activeDetail
                });
            }
        }

        next() {
            const nextIndex = this.activeDetailIndex;
            if(this.details[nextIndex]) {
                this._activeDetails(nextIndex);
                this._getActiveDetails();
                this.onRouteChange({
                    $event: this.activeDetail
                });
            }
        }

        _viewDetails() {
            this.viewDetails({
                $event: this.activeDetail
            });
        }

        _getActiveDetails() {
            this.activeDetail = head(filter(this.details, detail => detail.isSelected));
            this.activeDetailIndex = findIndex(this.details, { isSelected: true }) + 1;
        }

        _activeDetails(activeIndex) {
            map(this.details, (detail, index) => {
                if(detail.isSelected) {
                    detail.isSelected = false;
                }
                if(index === activeIndex) {
                    detail.isSelected = true;
                }
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/trip-provider-slider/trip-provider-slider.component.js